import React from 'react';
import { Spin } from 'antd';

/**
 * Loading spinner component for search results
 * @returns {JSX.Element} Loading spinner
 */
const LoadingState = () => (
  <div className="flex justify-center py-8">
    <Spin size="large" />
  </div>
);

export default LoadingState;